import angular from 'angular';
import { PartnerLinksService } from './service/PartnerLinksService';
import { partnerLinksListComponent } from './list/partnerLinksListComponent';
import { partnerLinksTriggerComponent } from './trigger/partnerLinksTriggerComponent';

angular
	.module('sh.partnerLinks', ['sh.api', 'ui.router'])
	.component('shPartnerLinksList', partnerLinksListComponent())
	.component('shPartnerLinksTrigger', partnerLinksTriggerComponent())
	.service('PartnerLinks', PartnerLinksService);
